import React, { useContext, useEffect } from "react";
import SidebarContext from "../../contexts/MyContext";
import { truncateFileName } from "../../utils/truncateFileName";
import AdjustAudio from "../Waveform/AdjustAudio";
import { useTrackNavigation } from "../../utils/trackNavigationUtils";
import { Icon } from "@iconify/react";
import "../../css/app/aiResults.css";

// Lets role="button" images respond to Enter/Space like real buttons.
const activateOnKey = (e) => { if (e.key === "Enter" || e.key === " ") e.currentTarget.click(); };

const AdjustRecordingLogic = () => {
    const { selectedAdjustAudio, setSelectedAdjustAudio, setActionTabIndex, setAudio, audioIndex, listTabIndex, filterAudioData, favoriteAudio } = useContext(SidebarContext);
    const { isPrevDisabled, isNextDisabled, playPreviousTrack, playNextTrack } = useTrackNavigation();

    // A file picked in AI Tools is not in the recording list yet, so it must not be replaced by it.
    const isLocalUpload = selectedAdjustAudio?.isLocalUpload === true;

    useEffect(() => {
        if (isLocalUpload) return;
        if (selectedAdjustAudio) {
            setSelectedAdjustAudio(listTabIndex === 1 ? filterAudioData[audioIndex] : favoriteAudio[audioIndex]);
        }
    }, [audioIndex, filterAudioData, favoriteAudio, listTabIndex, isLocalUpload]);

    // Closing the screen is the only way back out, so the object URL is dropped there.
    const closeAdjustScreen = () => {
        if (isLocalUpload) {
            URL.revokeObjectURL(selectedAdjustAudio?.audio?.url);
            setSelectedAdjustAudio([]);
            setActionTabIndex(null);
            setAudio();
            return;
        }
        setActionTabIndex(null);
        setAudio(selectedAdjustAudio);
    };

    const folderId = selectedAdjustAudio?.folderId || selectedAdjustAudio?.audio?.folderId || '';

    return (
        <div className="vr-air vr-air-adjust vr-tone-blue">
            {!selectedAdjustAudio || selectedAdjustAudio?.length == 0 ? (
                <div className="vr-air-empty">
                    <img src="/img/trim/trim_img.png" />
                    <h3 className="vr-air-empty-title">
                        Select Recording to Adjust
                    </h3>
                    <p className="vr-air-empty-text">
                        Pick a recording from the list to reduce noise, enhance the voice, boost the volume or change its speed.
                    </p>
                </div>
            ) : (
                <>
                    <header className="vr-air-head">
                        <div className="vr-icon-tile is-solid vr-air-head-tile">
                            <Icon icon="lucide:sliders-horizontal" width="20" height="20" />
                        </div>
                        <div className="vr-air-head-text">
                            <h6 className="vr-air-title">
                                Adjust
                            </h6>
                            <div className="vr-air-meta">
                                <Icon icon="lucide:audio-lines" width="15" height="15" className="vr-air-meta-icon" />
                                <h6 className="vr-air-file">
                                    {truncateFileName(selectedAdjustAudio?.audio?.fileName, 35)}
                                </h6>
                            </div>
                        </div>
                        <img src="./img/cancelIcon.png" height={24} width={24} onClick={closeAdjustScreen} className="vr-air-close" alt="Close" role="button" tabIndex={0} onKeyDown={activateOnKey} />
                    </header>
                    <AdjustAudio
                        audioName={selectedAdjustAudio?.audio?.fileName}
                        audioId={selectedAdjustAudio?._id}
                        audioUrl={selectedAdjustAudio?.audio?.url}
                        folderId={folderId}
                        isLocalUpload={isLocalUpload}
                        isPrevDisabled={isLocalUpload || isPrevDisabled}
                        isNextDisabled={isLocalUpload || isNextDisabled}
                        playNextTrack={playNextTrack}
                        playPreviousTrack={playPreviousTrack}
                    />
                </>
            )}
        </div>
    );
};

export default AdjustRecordingLogic;
